/*
    Description: js general overlay/modal class
    Author URI: https://destinationsalesandmarketinggroup.com/
    Author: adillice
    Version: 1.0.0
*/
// overlay/modal class
class Overlay{

    // constructor
    constructor({ 
        modalSelector = ".modal-overlay",
        modalWrapperSelector = ".modal__wrapper",
        buttonSelector = ".overlay",
        hideClassName = "--hide",
        closeSelector = "--close",
        scrollSelector = "--noscroll",
        backgroundSelector = "--dark-bg",
        slideSelector = "--modal-slide",
        ariaMsgSelector = "--aria-msg",
        callback = null,
        title = "",
        body = ""
    } = {}){

        //init class that opens the modal
        this.modalClass = modalSelector; 

        // init modal wrapper class
        this.modalWrapperClass = modalWrapperSelector; 

        // setup hide class
        this.hideClass = hideClassName;

        // setup close bttn class
        this.close = closeSelector;

        // setup bttn selector
        this.bttnSelector = buttonSelector;

        // aria msg area selector
        this.ariaMsg = ariaMsgSelector;

        // setup scroll disable class
        this.noScroll = scrollSelector;

        // setup modal slide class
        this.modalSlide = slideSelector;

        // setup modal background
        this.bg = backgroundSelector;

        //grab selector
        this.bttn = document.querySelectorAll(this.bttnSelector);
        this.body = document.getElementsByTagName("body");

        // init callback
        this.callback = callback;

        //init title content
        this.titleContent = title; 
        
        //init body content
        this.bodyContent = body; 

        // overlay visibililty status
        this.hide = true;

        // speed
        this.speed = 500;

        // init element that fired off the overlay
        this.overlayOpener;

        // setup events
        this.events();

    }

    //EVENTS methods
    events(){

        // if button does not exist then it maybe dynamic -- so look for it later
        if((!this.bttn)||(this.bttn.length <= 0)){

            // add event listener to the body
            if(this.body[0]) this.body[0].addEventListener("click", (e) => {

                // get target
                const target = e.target,
                reportClassName = this.bttnSelector.replace(/[.#]+/g, '');
                
                //check if we clicked our bttnSelector element
                if(target.classList.contains(reportClassName)){
                    
                    // add overlay
                    this.addOverlay(e);
                    
                }

            });

        } 

        // loop - go thru buttons
        for(const thisBttn of this.bttn){

            // add mousedown (prevent conflict with focus) event listener
            thisBttn.addEventListener("mousedown", this.addOverlay.bind(this));
            
            // add event keyup
            thisBttn.addEventListener("keyup", (e) => {

                // check if enter was pressed
                if(e.key.toLowerCase() === "enter"){

                    // add overlay
                    this.addOverlay(e);
                    
                }
                
            });

        }

    }
    
    //close bttn
    closeOverlay(e){

        // fire off display overlay method
        if(e.target && e.target.classList.contains(this.close)) this.displayOverlay();
        
    }
    
    //update visibility status
    displayOverlay(forceClose = false){

        // switch this.hide status
        this.hide = !this.hide;

        //force close -- used for escape press
        this.hide = (forceClose) ? true : this.hide;

        // try to grab modal and modal body
        const modal = document.querySelector(this.modalClass),
        modalWrapper = (modal) ? modal.querySelector(this.modalWrapperClass) : null,
        modalBody = (modalWrapper) ? modalWrapper.querySelector(".modal__wrapper__body") : null,
        modalFooterMsgArea = (modal) ? modal.querySelector(".modal__wrapper__footer__messages") : null;

        // try to grab body tag
        const body = document.getElementsByTagName("body")[0];

        // make sure modal and modal wrapper exists
        if(modal && modalWrapper){

            //HIDE: check visibility status
            if(this.hide){

                // enable background from screen readers
                if(body) body.children[0].setAttribute("aria-hidden", "false");

                // add remove slide class to modal wrapper
                modalWrapper.classList.remove(this.modalSlide);

                // create delay for modal slide in
                const hideDelay = setTimeout((e) => {

                    // modal set aria-hidden attribute
                    modal.setAttribute("aria-hidden", "true");

                    // add hide class
                    modal.classList.add(this.hideClass);

                    // remove no scroll from body tag
                    body.classList.remove(this.noScroll);

                    // add focus back on opener
                    if(this.overlayOpener) this.overlayOpener.focus({preventScroll:true});

                    // reset body after modal closes
                    if(modalBody){
                        
                        // clean up body content
                        modalBody.innerHTML = this.bodyContent;

                        // clean up classes
                        modalBody.removeAttribute("class");
                        modalBody.classList.add("modal__wrapper__body");

                    }

                    // reset footer msg area
                    if(modalFooterMsgArea){

                        // clean up content
                        modalFooterMsgArea.innerHTML = "";

                        // clean up classes
                        modalFooterMsgArea.removeAttribute("class");
                        modalFooterMsgArea.classList.add("modal__wrapper__footer__messages");

                    }

                    // clear time out
                    clearTimeout(hideDelay);
                
                // timeout speed
                }, this.speed);

            //SHOW
            }else{

                // disable background from screen readers
                if(body) body.children[0].setAttribute("aria-hidden", "true");

                // modal set aria-hidden attribute
                modal.setAttribute("aria-hidden", "false");

                // remove hide class
                modal.classList.remove(this.hideClass);
                
                // show delay
                const showDelay = setTimeout((e) => {

                    // add class slide class to modal wrapper
                    modalWrapper.classList.add(this.modalSlide);

                    // clear time out
                    clearTimeout(showDelay);
                
                // delay speed
                }, 100);

                // focus on first input field
                if(modal.getElementsByTagName("input").length > 0) modal.getElementsByTagName("input")[0].focus({preventScroll:true});

                // add no scroll from body tag
                body.classList.add(this.noScroll);

            }
            
        }
        
    }

    //add overlay to DOM
    addOverlay(e){

        // default
        e.preventDefault();

        // pass element to overlayOpener
        this.overlayOpener = (e && e.target) ? e.target : null;

        // need to look for potential dynamic DOM element links in the body
        const dynamicLinks = (e && e.currentTarget && (e.currentTarget.nodeName.toLowerCase() === 'body')) ? ((e && e.target) ? e.target : null) : e.currentTarget,

        // check if overlay is already in DOM
        count = document.querySelectorAll(this.modalClass) ? document.querySelectorAll(this.modalClass).length : 0;

        // make sure we dont have other overlays
        if(count < 1){

            // add overlay
            this.body[0].appendChild(this.overlay());

            // try to grab modal
            const modal = document.querySelector(this.modalClass);

            // add accessibility setup - modal
            this.setupAccessibility(modal);

            // close the menu overlay when user clicks the escape key
            modal.addEventListener("keyup", (e) => {

                // check if closed button is currently focused
                const closeFocused = (document.activeElement) ? document.activeElement.classList.contains(this.close) : null;

                // check if escape was pressed
                if(e.key.toLowerCase() === "escape") this.displayOverlay(true);

                // close overlay when focused on close button and user hits enter
                if((e.key.toLowerCase() === "enter") && closeFocused) this.displayOverlay(true);

            });
            
            // check if modal exists
            if(!modal){

                // display error msg 
                console.log(`%c Error: Could not find the element using the selector: '${this.modalClass}'!!!`, 'background:#f00; color:#fff');
                return;
                
            }

            // get close bttn
            const closeBttns = modal.querySelectorAll(`.${this.close}`);

            // check if we have close bttns - or die silently
            if(closeBttns && closeBttns.length > 0){

                // loop
                for(const closeBttn of closeBttns){

                    // add event listener
                    closeBttn.addEventListener("click", this.closeOverlay.bind(this));

                }

            }

            // if we have a callback call it
            // ((this.callback)&&(typeof this.callback === 'function')) ? this.callback(passTarget) : null;
            
        }
        
        // fire off callback - with a potential dynamic link
        ((this.callback)&&(typeof this.callback === 'function')) ? this.callback(dynamicLinks) : null;
        
        // fire off display overlay method
        this.displayOverlay();  

    }

    //create overlay tags
    overlay(){

        //get modal class name
        const modalClassName = this.modalClass.replace(/\#|\./g,'');

        // modal background wrapper
        const final = document.createElement("div");
        final.classList.add("modal", modalClassName, this.bg);
        final.setAttribute("aria-hidden", "false");

            // modal wrapper
            const wrapper = document.createElement("div");
            wrapper.classList.add("modal__wrapper");
            wrapper.setAttribute("aria-modal", "true");
            wrapper.setAttribute("role", "dialog");

                // modal header
                const header = document.createElement("div");
                header.classList.add("modal__wrapper__header");

                    // modal title
                    const title = document.createElement("h2");
                    title.classList.add("modal__wrapper__header__title");
                    title.setAttribute("id", "modal-title");

                    // add title content if provided
                    (this.titleContent) ? title.innerHTML = this.titleContent : null;

                    // close button
                    const close = document.createElement("span");
                    close.setAttribute("aria-label", "press escape or click to close overlay");
                    close.classList.add("modal__wrapper__header__close", this.close);

            // modal body
            const body = document.createElement("div");
            body.classList.add("modal__wrapper__body");

            // add body content if provided
            (this.bodyContent) ? body.innerHTML = this.bodyContent : null;
            
            // modal footer
            const footer = document.createElement("div");
            footer.classList.add("modal__wrapper__footer");

            // modal footer message- for success/error msgs
            const msg = document.createElement("div");
            msg.classList.add("modal__wrapper__footer__messages");

            // modal loading bar wrapper
            const loadingBarWrapper = document.createElement("div");
            loadingBarWrapper.classList.add("modal__wrapper__footer__loadingbar");

            // modal loading bar
            const loadingBar = document.createElement("div");
            loadingBar.classList.add("modal__wrapper__footer__loadingbar__bar");

        // build it out
        final.appendChild(wrapper);
        wrapper.appendChild(header);
        header.appendChild(title);
        header.appendChild(close);
        wrapper.appendChild(body);
        wrapper.appendChild(footer);
        footer.appendChild(msg);
        footer.appendChild(loadingBarWrapper);
        loadingBarWrapper.appendChild(loadingBar);

        // return
        return final;

    }

    // setup accessibility for each overlay
    setupAccessibility(overlay){

        // get all modal, modal wrapper, and all tabbable items
        const modal = overlay,
        close = (modal) ? modal.querySelector(`.${this.close}`) : null,
        tabbableItems = (modal) ? modal.querySelectorAll(`a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input:not([disabled]), [class*="__msg"], [class*="__footer__messages"], select:not([disabled])`) : null;

        // mak sure we have tabbable DOM items
        if(tabbableItems && (tabbableItems.length > 0)){

            // init count num
            let count = 15000;

            // LOOP thru tabbable items
            tabbableItems.forEach((item) => {
                
                // set tab index
                item.setAttribute("tabindex", count);

                // increment count
                count++;
                
            })
            
            // add tabindex to close bttn
            if(close) close.setAttribute("tabindex", (count + 1));

            // keep tabbing within boundry
            this.tabbingBoundry(overlay, tabbableItems, close);

        }

    }

    // keep tab focus within overlay
    tabbingBoundry(modal, tabbables, close){

        // make sure we have modal and tabbable array - or die silently
        if(modal && tabbables && close){

            // setup first and last tab DOM items
            const firstTab = tabbables[0], lastTab = close;

            // add key event
            modal.addEventListener('keydown', (e) => {

                // get current focused item in DOM
                const currentFocus = document.activeElement;

                // check for tab key
                if(e.key.toLowerCase() === "tab"){

                    // shift pressed also
                    if(e.shiftKey){

                        // check if we are on first tabindex
                        if(currentFocus === firstTab){

                            // prevent default
                            e.preventDefault();

                            // set focus on last item
                            lastTab.focus({preventScroll:true});

                        }

                    // just tab pressed
                    }else{

                        // check if we are on last tabindex
                        if(currentFocus === lastTab){

                            // prevent default
                            e.preventDefault();

                            // set focus on first tab item
                            firstTab.focus();

                        }

                    }

                }

            });

        }

    }

}

// export
export default Overlay;